<template style="">
  <div class="All_data">
    <div class="All_data_bac">
      <ul class="All_data_top">
        <li style="width: 25%;color: #fff;font-size: 20px;text-align: center;" class="All_data_topli1">
          <p style="margin-top: 25px;">{{ new Date().getFullYear() }}-{{ new Date().getMonth() + 1 }}-{{ new Date().getDate() }} 星期{{ weeks }} </p>

        </li>
        <li style="width: 50%;font-size: 28px;text-align: center;color: rgba(0, 145, 255, 1);font-weight: 700;">
          <p style="margin-top: 20px;">北辰心理大数据中心通用版</p>
        </li>
        <li style="width: 25%;color: #fff;font-size: 20px;text-align: center;">
          <p style="margin-top: 25px;">
            <el-date-picker v-model="value1" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd" @change="Time_switching()">
            </el-date-picker>
          </p>
        </li>
      </ul>

      <el-row :gutter="20">
        <el-col :span="6">
          <div class="nav">
            <div ref="anxietyAndDepressionStatistic"
              style="width: 100%;background-color: rgba(19, 34, 77, 0.5);height: 100%;"></div>
          </div>
          <div class="nav">
            <div ref="get16pfPersonalityQuantization"
              style="width: 100%;background-color: rgba(19, 34, 77, 0.5);height: 100%;"></div>
          </div>
          <div class="nav">
            <div ref="pfComparisonDiagram" style="width: 100%;background-color: rgba(19, 34, 77, 0.5);height: 100%;">
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <div style="height: 67%;position: relative;">
              <ul class="grid-content-nav">
                <li>
                  <div class="YJRSBL">
                    <span>预警人数比例</span>
                    <i>{{numFilter(PsychologicalTestsStatistics.proportionOfPopulation)}}</i>
                  </div>
                  <div class="XLZTRS">
                    <span>心理状态人数</span>
                    <i>{{PsychologicalTestsStatistics.mentalStateNumber}}</i>
                  </div>
                  <div class="JJYJRS">
                    <span>焦虑预警人数</span>
                    <i>{{PsychologicalTestsStatistics.anxietyNumber}}</i>
                  </div>
                </li>
                <li style="margin-left: 20%;">
                  <div class="ZCPRS">
                    <span>总测评人次</span>
                    <i>{{PsychologicalTestsStatistics.totalAssessmentNumber}}</i>
                  </div>
                  <div class="XLJKZSJF">
                    <span>心理健康指数均分</span>
                    <i>{{numFilter(PsychologicalTestsStatistics.exponentialEquipartition)}}</i>
                  </div>
                  <div class="YYYJRS">
                    <span>抑郁预警人数</span>
                    <i>{{PsychologicalTestsStatistics.depressionNumber}}</i>
                  </div>
                </li>
              </ul>

              <div style="width:200px;height:80px;position:absolute;top: 46%;left: 0px;right: 0px;bottom: 0px;margin: auto;">
                <p style="color:#fff;font-size:34px;font-weight:700;text-align:center;">总预警人数</p>
                <p style="color:#fff;font-size:34px;font-weight:700;text-align:center;margin-top:20px;">{{ PsychologicalTestsStatistics.totalNumber }}</p>
              </div>
              
            </div>
            <div style="width: calc(50% - 20px);height: calc(33% - 12px);float: left;">
              <div ref="getSymptomCheckList90" style="width: 100%;background-color: rgba(19, 34, 77, 0.5);height: 100%;">
              </div>
            </div>
            <div style="width: calc(50% - 20px);height: calc(33% - 12px);background-color: rgba(19, 34, 77, 0.5);float: left;margin-left: 20px;">
              <div ref="getSymptomScores" style="width: 100%;background-color: rgba(19, 34, 77, 0.5);height: 100%;"></div>
            </div>
          </div>
        </el-col>

        <el-col :span="6">
          <div class="grid-content bg-purple">
            <!-- 焦虑和抑郁自测量表预警情况 -->
            <div class="nav" style="background-color: rgba(19, 34, 77, 0.5);">
              <div ref="getEysenckPersonalityComparison" style="width: 50%;height: 100%;float: left;"></div>
              <ul style="width: 50%;float: right;height: 100%;color: #fff;margin-top: 40px;">
                <li style="color: rgba(46, 136, 240, 1);">
                  <p>{{getEysenckPersonalityComparison.psychoticismNumber}}人 | {{numFilter(getEysenckPersonalityComparison.psychoticismPercentage)}}%</p>
                  <p>精神质</p>
                </li>
                <li style="margin-top: 10px;color: rgba(52, 186, 179, 1);">
                  <p>{{getEysenckPersonalityComparison.introvertNumber}}人 | {{numFilter(getEysenckPersonalityComparison.introvertPercentage)}}%</p>
                  <p>内向性</p>
                </li>
                <li style="margin-top: 10px;color: rgba(224, 191, 101, 1);">
                  <p>{{getEysenckPersonalityComparison.nervousnessNumber}}人 | {{numFilter(getEysenckPersonalityComparison.nervousnessPercentage)}}%</p>
                  <p>神经质</p>
                </li>
                <li style="margin-top: 10px;color: rgba(222, 93, 93, 1);">
                  <p>{{getEysenckPersonalityComparison.concealmentNumber}}人 | {{numFilter(getEysenckPersonalityComparison.concealmentPercentage)}}%</p>
                  <p>掩饰性</p>
                </li>
              </ul>
            </div>
            <div class="nav">
              <div ref="MinnesotaMultinomialPersonality" style="width: 100%;background-color: rgba(19, 34, 77, 0.5);height: 100%;"></div>
            </div>
            <div class="nav">
              <div ref="AgeGroupPopulationProportion" style="width: 100%;background-color: rgba(19, 34, 77, 0.5);height: 100%;"></div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      value1: '',
      weeks: "",
      anxietyAndDepressionStatistics: '',
      get16pfPersonalityQuantizationIndex: '',
      getSymptomCheckList90: '',
      getSymptomScores90: '',
      getEysenckPersonalityComparison: [],
      getMinnesotaMultinomialPersonality: '',
      getAgeGroupPopulationProportion: '',
      getget16pfComparisonDiagram: [],
      PsychologicalTestsStatistics: [],
    }
  },
  mounted() {
    this.$Http_Post('statistics/getPsychologicalTestsStatistics').then((res) => {//16pf个性量化指数各因子比较图
      if (res.Code == 200 || res.Code == 0) {
        this.PsychologicalTestsStatistics = res.Data;
      }
    })
    var datatiem = new Date().getDay();
    if (datatiem == 0) {
      this.weeks = "日";
    } else if (datatiem == 1) {
      this.weeks = "一";
    } else if (datatiem == 2) {
      this.weeks = "二";
    } else if (datatiem == 3) {
      this.weeks = "三";
    } else if (datatiem == 4) {
      this.weeks = "四";
    } else if (datatiem == 5) {
      this.weeks = "五";
    } else if (datatiem == 6) {
      this.weeks = "六";
    }
    this.anxietyAndDepressionStatistic();
    this.get16pfPersonalityQuantization();
    this.getSymptomCheckList();
    this.getSymptomScores();
    this.EysenckPersonalityComparison();
    this.MinnesotaMultinomialPersonality();
    this.AgeGroupPopulationProportion();
    this.pfComparisonDiagram();
  },

  methods: {
    Time_switching(){},
    numFilter(value) {
      const realVal = parseFloat(value).toFixed(2);
      return realVal;
    },
    anxietyAndDepressionStatistic() {
      this.$Http_Post('statistics/anxietyAndDepressionStatistics').then((res) => {//16pf个性量化指数各因子比较图
        if (res.Code == 200 || res.Code == 0) {
          var myChart = this.$echarts.init(this.$refs.anxietyAndDepressionStatistic);
          var option = {
            title: {
              text: '焦虑和抑郁自测量表预警情况',
              textStyle: { fontSize: 16, color: '#ffffff' },
              left: '20px',
              subtext:'焦虑总人数： '+res.Data.anxietyHeadcount +' 人'+ '抑郁总人数： ' + res.Data.depressedHeadcount + ' 人'
            },
            legend: {
              x: "70%", //图例位置，设置right发现图例和文字位置反了，设置一个数值就好了
              y: "10%", //延Y轴居中
              textStyle: {
                color: '#ffffff',//字体颜色
              },
              itemHeight: 10,
            },
            color: [
              "rgba(102, 255, 255, 1)",
              "rgba(56, 122, 255, 1)",
            ],
            tooltip: {
              trigger: 'axis',
              axisPointer: {// 坐标轴指示器，坐标轴触发有效
                type: 'shadow'// 默认为直线，可选为：'line' | 'shadow'
              },
              
              formatter: function (params) {
                var tip = "";
                let marker0 = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:rgba(102, 255, 255, 1);"></span>'
                let marker2 = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:rgba(56, 122, 255, 1)"></span>'

                tip = tip + marker0  + '焦虑' + params[0].value[1] + '人/'+ params[0].value[3] + '%' +  '<br/>';
                tip = tip + marker2  + '抑郁' + params[0].value[2] + '人/' + params[0].value[4] + '%' +   '<br/>';
                return tip
              }
            },
            dataset: {
              source: [
                ['product', '焦虑', '抑郁'],
                ['正常', res.Data.anxietyNormal, res.Data.depressedNormal, res.Data.anxietyNormalPercentage, res.Data.depressedNormalPercentage],
                ['轻度', res.Data.anxietyMild, res.Data.depressedMild, res.Data.anxietyMildPercentage, res.Data.depressedMildPercentage],
                ['中度', res.Data.anxietyModerate, res.Data.depressedModerate, res.Data.anxietyModeratePercentage, res.Data.depressedModeratePercentage],
                ['重度', res.Data.anxietySevere, res.Data.depressedSevere, res.Data.anxietySeverePercentage, res.Data.depressedSeverePercentage],
              ]
            },
            xAxis: {
              type: 'category',
              nameTextStyle: {//y轴上方单位的颜色
                color: '#fff'
              },
              axisLabel: {
                show: true,
                color: '#ffffff',
                fontSize: 12
              },
            },
            yAxis: {
              axisLabel: {
                show: true,
                color: '#ffffff',
                fontSize: 12
              },
            },
            series: [{ type: 'bar', barWidth: 13 }, { type: 'bar', barWidth: 13 },]
          };
          myChart.setOption(option);
          window.addEventListener("resize", function () {
            myChart.resize();
          });
        }
      })
    },
    get16pfPersonalityQuantization() {//16pf个性量化指数
      this.$Http_Post('statistics/get16pfPersonalityQuantizationIndex').then((res) => {//16pf个性量化指数各因子比较图
        if (res.Code == 200 || res.Code == 0) {
          var myChart = this.$echarts.init(this.$refs.get16pfPersonalityQuantization);
          var option = {
            tooltip: {
              trigger: 'item'
            },
            title: {
              text: '16PF个性量化指数',
              textStyle: { fontSize: 16, color: '#ffffff' },
              left: '20px'
            },
            color: ['rgba(222, 93, 93, 1)', 'rgba(58, 176, 252, 1)', 'rgba(56, 173, 169, 1)', 'rgba(224, 191, 101, 1)', 'rgba(242, 147, 58, 1)'],
            series: [
              {
                type: 'pie',
                radius: ['50%','70%'],
                center: ['50%','50%'],
                label: {
                  show: true,
                  formatter(param) {
                    return param.name + '(' + param.percent + '%)';
                  }
                },
                data: [
                  {value: res.Data.severePercentage, name: '重度' },//严重的百分比
                  {value: res.Data.moderatePercentage, name: '好' },//温和的百分比
                  {value: res.Data.normalPercentage, name: '正常' },//正常的比例
                  {value: res.Data.mildPercentage, name: '轻度' },//轻微的百分比
                  {value: res.Data.heavierPercentage, name: '中度' },//较重的比例
                  {itemStyle: {color: 'none',decal: {symbol: 'none'}},label: {show: false}}
                ]
              }
            ]
          };
          myChart.setOption(option);
          window.addEventListener("resize", function () {
            myChart.resize();
          });
        }
      })
    },
    // 词云图
    pfComparisonDiagram() {
      this.$Http_Post('statistics/get16pfComparisonDiagram').then((res) => {//16pf个性量化指数各因子比较图
        if (res.Code == 200 || res.Code == 0) {
          this.getget16pfComparisonDiagram = res.Data;

          console.log(res.Data)
          var myChart = this.$echarts.init(this.$refs.pfComparisonDiagram);
          var option = {
            title: {
              text: '16PF个性量化指数各因子比较图',
              textStyle: { fontSize: 16, color:'#ffffff'},
              left: '20px'
            },
            series: [
              {
                type: 'wordCloud',
                left: '1%',             //X轴偏移量
                top: '0%',              //Y轴偏移量
                width: '100%',          //canvas宽度大小
                height: '100%',         //canvas高度大小
                sizeRange: [8, 28],     //词典字体大小范围配置
                rotationRange: [0, 60], //词典字体旋转角度配置，默认不旋转
                gridSize: 12,           //词典字体间距配置
                layoutAnimation: true,  //为false词典过度会阻塞
                textStyle: {            //词典样式配置
                  normal: {
                    color() {
                      let colors = ['rgba(83, 166, 5, 1)', 'rgba(150, 95, 227, 1)', 'rgba(102, 255, 255, 1)', 'rgba(242, 189, 53, 1)', '#9E87FFb3', '#9E87FFb3', '#fe9a8bb3', '#fe9a8bb3', '#fe9a8bb3', '#73DDFF', '#58D5FF']
                      return colors[parseInt(Math.random() * 10)]
                    }
                  }
                },
                data: this.Conversion(this.getget16pfComparisonDiagram)
              }
            ]
          };
          myChart.setOption(option);
          window.addEventListener("resize", function () {
            myChart.resize();
          });
        }
      })
    },
    getSymptomCheckList() {//90项症状自评量表
      this.$Http_Post('statistics/getSymptomCheckList90').then((res) => {//16pf个性量化指数各因子比较图
        if (res.Code == 200 || res.Code == 0) {
          var myChart = this.$echarts.init(this.$refs.getSymptomCheckList90);
          var option = {
            tooltip: {
              trigger: 'item'
            },
            title: {
              text: '90项症状自评量表',
              textStyle: { fontSize: 16, color: '#ffffff' },
              left: '20px',
              top: '10px'
            },
            color: ['rgba(222, 93, 93, 1)', 'rgba(58, 176, 252, 1)', 'rgba(56, 173, 169, 1)', 'rgba(224, 191, 101, 1)', 'rgba(242, 147, 58, 1)'],
            series: [
              {
                type: 'pie',
                radius: ['50%','70%'],
                center: ['50%','55%'],
                label: {show: true,formatter(param) {return param.name + '(' + param.percent + '%)'}},
                data: [
                  { value: res.Data.severePercentage, name: '重度'},//严重的百分比
                  { value: res.Data.moderatePercentage, name: '好'},//温和的百分比
                  { value: res.Data.normalPercentage, name: '正常'},//正常的比例
                  { value: res.Data.mildPercentage, name: '轻度'},//轻微的百分比
                  { value: res.Data.heavierPercentage, name: '中度'},//较重的比例
                  {itemStyle: {color: 'none',decal: {symbol: 'none'}},label: {show: false}}
                ]
              }
            ]
          };
          myChart.setOption(option);
          window.addEventListener("resize", function () {
            myChart.resize();
          });
        }
      })
    },
    getSymptomScores() {//90项症状清单各因子得分情况
      this.$Http_Post('statistics/getSymptomScores90').then((res) => {//16pf个性量化指数各因子比较图
        if (res.Code == 200 || res.Code == 0) {
          var myChart3 = this.$echarts.init(this.$refs.getSymptomScores);
          var option = {
            title: {
              text:'90项症状清单各因子得分情况',
              textStyle:{fontSize:16,color:'#ffffff'},
              left:'20px',
              top:'10px',
            },
            dataset: {
              source: [
                [res.Data[9].factorName,res.Data[9].averageScore],
                [res.Data[8].factorName,res.Data[8].averageScore],
                [res.Data[7].factorName,res.Data[7].averageScore],
                [res.Data[6].factorName,res.Data[6].averageScore],
                [res.Data[5].factorName,res.Data[5].averageScore],
                [res.Data[4].factorName,res.Data[4].averageScore],
                [res.Data[3].factorName,res.Data[3].averageScore],
                [res.Data[2].factorName,res.Data[2].averageScore],
                [res.Data[1].factorName,res.Data[1].averageScore],
                [res.Data[0].factorName,res.Data[0].averageScore],
              ]
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              },
              textStyle: { // 设置提示框的对齐方式
                align: 'left'
              }
            },
            legend: {
              show: false
            },
            grid: {
              left:'2%',
              right:'5%',
              top:'50px',
              bottom:'10px',
              containLabel:true
            },
            xAxis: {
              axisLabel:{
                show:true,
                color:'#ffffff',
                fontSize:12
              },
            },
            yAxis: {
              type:'category',
              axisLabel:{
                show:true,
                color:'#ffffff',
                fontSize:12
              },
            },
            series: [
              {
                type: 'bar',
                barWidth: 13,
                itemStyle: { // 柱状图的背景色
                  normal: {
                    // 每个柱子的颜色即为colorList数组里的每一项,如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                    color: function (params) {
                      var index = params.dataIndex
                      var colorList = [
                        [
                          'rgba(86, 204, 204, 1)',
                          'rgba(86, 204, 204, 1)',
                          'rgba(86, 204, 204, 1)',
                          'rgba(86, 204, 204, 1)',
                          'rgba(86, 204, 204, 1)',
                          'rgba(86, 204, 204, 1)',
                          'rgba(86, 204, 204, 1)',
                          'rgba(86, 204, 204, 1)',
                          'rgba(86, 204, 204, 1)',
                          'rgba(86, 204, 204, 1)'
                        ], 
                        [
                          'rgba(177, 237, 159, 1)',
                          'rgba(177, 237, 159, 1)',
                          'rgba(177, 237, 159, 1)',
                          'rgba(177, 237, 159, 1)',
                          'rgba(177, 237, 159, 1)',
                          'rgba(177, 237, 159, 1)',
                          'rgba(177, 237, 159, 1)',
                          'rgba(177, 237, 159, 1)',
                          'rgba(177, 237, 159, 1)',
                          'rgba(177, 237, 159, 1)']
                      ]
                      return {
                        colorStops: [{
                          offset: 0.3, // 颜色的开始位置
                          color: colorList[0][index] // 0% 处的颜色
                        },
                        {
                          offset: 0.6, // 颜色的结束位置
                          color: colorList[1][index] // 100% 处的颜色
                        }]
                      }
                    }
                  }
                }
              }
            ]
          }
          myChart3.setOption(option);
          window.addEventListener("resize", function () {
            myChart3.resize();
          });
        }
      })
    },
    EysenckPersonalityComparison() {
      this.$Http_Post('statistics/getEysenckPersonalityComparison').then((res) => {//16pf个性量化指数各因子比较图
        if (res.Code == 200 || res.Code == 0) {
          this.getEysenckPersonalityComparison = res.Data;
          var myChart = this.$echarts.init(this.$refs.getEysenckPersonalityComparison);
          var option = {
            title: {
              text:'艾森克个性比较图',
              textStyle:{fontSize:16,color:'#ffffff'},
              left:'20px',
              top:'10px',
            },
            polar:{radius:[30,'80%']},
            angleAxis:{
              max:100,
              startAngle:90,
              splitLine:{show:false},
              axisLabel:{show:false},
              axisLine:{show:false},
              axisTick:{show:false},
            },
            radiusAxis: {
              type:'category',
              show:false,//不让指针线显示
              data:['精神质','内向性','神经质','掩饰性'],
            },
            tooltip:{},
            series:{
              type:'bar',
              data:[res.Data.psychoticismPercentage,res.Data.introvertPercentage,res.Data.nervousnessPercentage,res.Data.concealmentPercentage],
              barWidth:10,
              coordinateSystem:'polar',
              itemStyle:{
                normal:{
                  color:function (params) {
                    var colorList = ['rgba(0, 116, 199, 1)','rgba(0, 186, 173, 1)','rgba(224, 191, 101, 1)','rgba(222, 93, 93, 1)']
                    return colorList[params.dataIndex]
                  },
                },
              },
              label: {
                show:true,
                position:'middle',
                formatter:'{b}: {c}({d}%)',
              },
            },
          }
          myChart.setOption(option);
          window.addEventListener("resize", function () {
            myChart.resize();
          });
        }
      })
    },
    MinnesotaMultinomialPersonality() {
      this.$Http_Post('statistics/getMinnesotaMultinomialPersonality').then((res) => {//16pf个性量化指数各因子比较图
        if (res.Code == 200 || res.Code == 0) { 
          var myChart = this.$echarts.init(this.$refs.MinnesotaMultinomialPersonality);
          var option = {
            title: {
              text: '明尼苏达多相人格测验简式',
              textStyle: {fontSize: 16,color:'#ffffff'},
              left: '20px'
            },
            color: [
              "rgba(56, 122, 255, 1)",
            ],
            xAxis: {
              type:'category',
              nameTextStyle: {//y轴上方单位的颜色
                color:'#fff'
              },
              data:['正常','轻度','中度','较重','重度'],
              axisLabel: {
                show: true,
                color: '#ffffff',
                fontSize: 12
              },
            },
            yAxis: {
              axisLabel: {
                show: true,
                color: '#ffffff',
                fontSize: 12
              },
            },
            series: [
              {
                data: [res.Data.normal, res.Data.mild, res.Data.moderate, res.Data.heavier, res.Data.severe],
                type: 'bar',
                barWidth: 13
              }
            ]
          }
          myChart.setOption(option);
          window.addEventListener("resize", function () {
            myChart.resize();
          });
        }
      })
    },
    AgeGroupPopulationProportion() {
      this.$Http_Post('statistics/getAgeGroupPopulationProportion').then((res) => {//焦虑和抑郁自测量表预警情况
        if (res.Code == 200 || res.Code == 0) {
          this.anxietyAndDepressionStatistics = res.Data;
          var normal = [];//正常
          var mild = [];//轻度
          var moderate = [];//中度
          var heavier = [];//较重
          var heavy = [];//重
          var normal = [res.Data[0].sixToEighteen, res.Data[0].eightTeenToThirty, res.Data[0].thirtyToFourty, res.Data[0].fourtyToFifty, res.Data[0].fiftyToSixty, res.Data[0].sixtyToSeventy, res.Data[0].upSeventy];//正常
          var mild = [res.Data[1].sixToEighteen, res.Data[1].eightTeenToThirty, res.Data[1].thirtyToFourty, res.Data[1].fourtyToFifty, res.Data[0].fiftyToSixty, res.Data[1].sixtyToSeventy, res.Data[1].upSeventy];//轻度
          var moderate = [res.Data[2].sixToEighteen, res.Data[2].eightTeenToThirty, res.Data[2].thirtyToFourty, res.Data[2].fourtyToFifty, res.Data[0].fiftyToSixty, res.Data[2].sixtyToSeventy, res.Data[2].upSeventy];//中度
          var heavier = [res.Data[3].sixToEighteen, res.Data[3].eightTeenToThirty, res.Data[3].thirtyToFourty, res.Data[3].fourtyToFifty, res.Data[0].fiftyToSixty, res.Data[3].sixtyToSeventy, res.Data[3].upSeventy];//较重
          var heavy = [res.Data[4].sixToEighteen, res.Data[4].eightTeenToThirty, res.Data[4].thirtyToFourty, res.Data[4].fourtyToFifty, res.Data[0].fiftyToSixty, res.Data[4].sixtyToSeventy, res.Data[4].upSeventy];//重
          var myChart = this.$echarts.init(this.$refs.AgeGroupPopulationProportion);
          var datas = [normal, mild, moderate, heavier, heavy];
          var option = {
            title: {
              text: '不同年龄段和性别预警人数占比',
              textStyle: { fontSize: 16, color: '#ffffff' },
              left: '20px'
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {//坐标轴指示器，坐标轴触发有效
                type: 'shadow'//默认为直线，可选为：'line' | 'shadow'
              },
            },
            legend: {
              data: ['正常','轻度','中度','较重','重度'],
              x: "15%",
              y: "12%",
              textStyle: {
                color: '#ffffff',//字体颜色
              },
              itemHeight: 10,
            },
            xAxis: [
              {
                type: 'category',
                nameTextStyle: {//y轴上方单位的颜色
                  color: '#fff'
                },
                axisLabel: {
                  show: true,
                  color: '#ffffff',
                  fontSize: 12
                },
                splitLine: {
                  show: false
                },
                data: ['6-18','19-30','30-40','50-60','60-70','70以上'],
              }
            ],
            yAxis: {
              axisLabel: {
                show: true,
                color: '#ffffff',
                fontSize: 12,
              },
            },
            series: [
              {
                name: '正常',
                type: 'bar',
                stack: '广告',
                data: datas[0],
                barWidth: 13,
                color: 'rgba(52, 178, 142, 1)'
              },
              {
                name: '轻度',
                type: 'bar',
                stack: '广告',
                data: datas[1],
                barWidth: 13,
                color: 'rgba(72, 206, 242, 1)'
              },
              {
                name: '中度',
                type: 'bar',
                stack: '广告',
                data: datas[2],
                barWidth: 13,
                color: 'rgba(242, 158, 72, 1)'
              },
              {
                name: '较重',
                type: 'bar',
                stack: '广告',
                data: datas[3],
                barWidth: 13,
                color: 'rgba(240, 113, 113, 1)'
              },
              {
                name: '重度',
                type: 'bar',
                stack: '广告',
                data: datas[4],
                barWidth: 13,
                color: 'rgba(242, 72, 72, 1)'
              }
            ],
            grid: {
              left: '4%',
              right: '4%',
              top: '80px',
              bottom: '20px',
              containLabel: true
            },
          }
          myChart.setOption(option);
          window.addEventListener("resize", function () {
            myChart.resize();
          });
        }
      })
    },
    Conversion(data) {
      var Conver = [];
      for (let i = 0; i < data.length; i++) {
        Conver.push({
          value: data[i].averageScore,
          name: data[i].factorName,
        })
      }
      return Conver;
    }
  },
}
</script>
<style>
.All_data {height: 100%;width: 100%;background-image: url('../../assets/6109ee0a914152149fb3830b.png');background-size: 100% 100%;}
.grid-content {height: 100%;}
.All_data .el-row {height: calc(100% - 60px)}
.All_data .el-col {height: calc(100% - 80px);margin-top: 10px;}
.All_data_top {height: 60px;background-image: url('../../assets/img_head_bg.png');background-size: 100% 100%;}
.All_data_top li {float: left;}
.All_data .el-range-editor.el-input__inner {width: 240px;height: 30px;background-color: rgba(33, 108, 194, 1);border: 1px solid #ffffff;}
.All_data .el-date-editor .el-range__icon {line-height: 24px;color: #fff;}
.All_data .el-date-editor .el-range-separator {line-height: 23px;color: #fff;}
.All_data .el-range-editor .el-range-input {background-color: rgba(33, 108, 194, 1);color: #fff;}
.nav {width: 94%;height: calc(33% - 12px);margin-left: 3%;border-image-source: radial-gradient(66% 70%, transparent 0px, transparent 100%, cyan 100%);border-image-slice: 1;border-width: 1px;border-style: solid;border-image-outset: 2px;margin-top: 10px;}
.nav canvas {width: 100%;height: 100%;margin-top: 10px;position: absolute;left: 0px !important;top: 14px !important;}
.nav_li1 {float: left;width: 285px;height: 116px;background-image: url('../../assets/img_center_01.png.png');background-size: 100% 100%;margin-left: 16%;line-height: 120px;color: rgba(191, 224, 255, 1);font-size: 16px;}
.nav_li1 i {margin-left: 70px;}
.nav_li1 span {margin-left: 40px;}
.nav_li3 i {margin-left: 86px;}
.nav_li3 span {margin-left: 40px;}
.nav_li2 {float: right;width: 285px;height: 116px;background-image: url('../../assets/60f8fac661957d72f5871f01.png');background-size: 100% 100%;margin-right: 16%;line-height: 120px;color: rgba(191, 224, 255, 1);font-size: 16px;}
.nav_li2 i {margin-left: 36px;}
.nav_li2 span {margin-left: 90px;}
.nav_li4 i {margin-left: 46px;}
.nav_li4 span {margin-left: 60px;}
.nav_li3 {float: left;width: 285px;height: 116px;background-image: url('../../assets/img_center_01.png.png');background-size: 100% 100%;margin-left: 8%;line-height: 120px;color: rgba(191, 224, 255, 1);font-size: 16px;}
.nav_li4 {float: right;width: 285px;height: 116px;background-image: url('../../assets/60f8fac661957d72f5871f01.png');background-size: 100% 100%;margin-right: 8%;line-height:120px;color: rgba(191, 224, 255, 1);font-size: 16px;}
.All_data_bac {width:100%;height:100%;margin:auto;background:url("../../assets/img_sanjiao_bg.gif") no-repeat center center;background-size: 35% 70%;}
.YJRSBL {background: url("../../assets/gif动画左边.gif")no-repeat center center;background-size: 100% 100%;width: 240px;height: 100px;margin-top: 20px;margin-left: 80px;position: relative;}
.XLZTRS {background: url("../../assets/gif动画左边.gif")no-repeat center center;background-size: 100% 100%;width: 240px;height: 100px;margin-top: 20px;margin-left: 50px;margin-top: 40px;position: relative;}
.JJYJRS {background: url("../../assets/gif动画左边.gif")no-repeat center center;background-size: 100% 100%;width: 240px;height: 100px;margin-top: 20px;margin-left: 20px;margin-top: 40px;position: relative;}
.YJRSBL span {color: #fff;font-size: 14px;margin-top: 42px;margin-left: 48px;display: inline-block;}
.XLZTRS span {color: #fff;font-size: 14px;margin-top: 42px;margin-left: 40px;display: inline-block;}
.JJYJRS span {color: #fff;font-size: 14px;margin-top: 42px;margin-left: 40px;display: inline-block;}
.YJRSBL i {color: #fff;font-size: 18px;padding-top: 40px;margin-left: 36px;display: inline-block;font-size: 20px;font-style: normal;display: inline-block;width: 80px;position: absolute;right: 8px;text-align: center;}
.XLZTRS i {color: #fff;font-size: 18px;margin-top: 40px;margin-left: 50px;display: inline-block;font-size: 20px;font-style: normal;display: inline-block;width: 80px;position: absolute;right: 8px;text-align: center;}
.JJYJRS i {color: #fff;font-size: 18px;margin-top: 40px;margin-left: 50px;display: inline-block;font-size: 20px;font-style: normal;display: inline-block;width: 80px;position: absolute;right: 8px;text-align: center;}

.ZCPRS {background: url("../../assets/gif动画右边.gif")no-repeat center center;background-size: 100% 100%;width: 240px;height: 100px;margin-top: 20px;margin-right: 80px;position: relative;float: right;}
.XLJKZSJF {background: url("../../assets/gif动画右边.gif")no-repeat center center;background-size: 100% 100%;width: 240px;height: 100px;margin-top: 20px;margin-right: 50px;margin-top: 40px;position: relative;float: right;}
.YYYJRS {background: url("../../assets/gif动画右边.gif")no-repeat center center;background-size: 100% 100%;width: 240px;height: 100px;margin-top: 20px;margin-right: 20px;margin-top: 40px;position: relative;float: right;}


.ZCPRS span {color: #fff;font-size: 14px;margin-top: 43px;margin-left: 110px;display: inline-block;}
.XLJKZSJF span {color: #fff;font-size: 14px;margin-top: 43px;margin-left: 110px;display: inline-block;}
.YYYJRS span {color: #fff;font-size: 14px;margin-top: 43px;margin-left: 110px;display: inline-block;}
.ZCPRS i {color: #fff;font-size: 18px;padding-top: 40px;display: inline-block;font-size: 20px;font-style: normal;display: inline-block;width: 80px;position: absolute;left: 8px;text-align: center;}
.XLJKZSJF i {color: #fff;font-size: 18px;margin-top: 40px;display: inline-block;font-size: 20px;font-style: normal;display: inline-block;width: 80px;position: absolute;left: 8px;text-align: center;}
.YYYJRS i {color: #fff;font-size: 18px;margin-top: 40px;display: inline-block;font-size: 20px;font-style: normal;display: inline-block;width: 80px;position: absolute;left: 8px;text-align: center;}



.nav_ul1 {
  margin-top: 20px;
  height: 118px;
}

.nav_ul2 {
  margin-top: 20px;
  height: 118px;
}

.nav_center h2 {
  text-align: center;
  color: #fff;
  padding-top: 200px;
  font-size: 26px;
}

.nav_center h3 {
  text-align: center;
  color: #fff;
  padding-top: 20px;
  font-size: 46px;
}

.grid-content-nav {
  width: 100%;
  height: 100%;
}

.grid-content-nav>li {
  width: 40%;
  height: 100%;
  float: left;
}




.All_data {
  box-sizing: border-box;
  padding-top: 16px;
  overflow-x: scroll;
  /* 设置溢出滚动 */
  white-space: nowrap;
  overflow-y: hidden;
  /* 隐藏滚动条 */
  scrollbar-width: none;
  /* firefox */
  -ms-overflow-style: none;
  /* IE 10+ */
}

.All_data::-webkit-scrollbar {
  display: none;
  /* Chrome Safari */
}</style>
